import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = { class: "filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100 mb-30" }
const _hoisted_3 = { class: "d-flex flex-column gap-10 col-md-6 col-sm-12" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "small striped toggle no-underline mt-30",
  id: "table-roster"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "First & Middle name"),
    /*#__PURE__*/_createElementVNode("th", null, "NBF Participant ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Suffix"),
    /*#__PURE__*/_createElementVNode("th", null, "D.O.B"),
    /*#__PURE__*/_createElementVNode("th", null, "Gender"),
    /*#__PURE__*/_createElementVNode("th", null, "Marital Status")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", { class: "large" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, " No results found. ")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { id: "print" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, "Currently Listed on " + _toDisplayString($setup.userName) + " Roster", 1)
      ]),
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        placeholder: "Search by NBF Participant ID, First or Last Name",
        max: 100,
        modelValue: $setup.filter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filter) = $event)),
        customClass: "search w-35 w-sm-100"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_MessageCard, {
      message: $setup.message,
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card__page"
    }, null, 8, ["message"]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-primary mt-10 ms-auto plan-modal",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.download && $setup.download(...args))),
            disabled: $setup.downloading
          }, [
            ($setup.downloading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Downloading PDF ..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "Download PDF"))
          ], 8, _hoisted_5),
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            ($setup.data.length > 0 && !$setup.loading)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data, (person) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: person.PersonID,
                      class: "large"
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "javascript;",
                          class: "plan-modal",
                          onClick: _withModifiers(($event: any) => ($setup.openModal('local-member-profile', 'Member Profile', 'plan-profile plan-tables profile', null, { PersonID: person.PersonID })), ["prevent"])
                        }, _toDisplayString(person.LastName), 9, _hoisted_11)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(person.FirstName) + " ", 1),
                        (person.MiddleName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, ", " + _toDisplayString(person.MiddleName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(person.PersonID), 1),
                      _createElementVNode("td", null, _toDisplayString(person.NameSuffix), 1),
                      (person.DateofBirth)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(person.DateofBirth), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_14, "Missing Info")),
                      _createElementVNode("td", null, _toDisplayString(person.Gender), 1),
                      _createElementVNode("td", null, _toDisplayString(person.MaritalStatus), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_15, _hoisted_17))
          ]),
          _hoisted_18,
          _createVNode(_component_PaginationComponent, {
            paginator: $setup.paginator,
            onFetchData: $setup.fetchPaginationData
          }, null, 8, ["paginator", "onFetchData"])
        ]))
  ]))
}